module.exports = __webpack_public_path__ + "img/23EE.a51e5537.svg";